@import '@hevoio/hevo-ui-toolkit/styles/variables';

.timeSelectorDropdown {
  display: flex;
  height: 200px;
  width: 100%;
  overflow-y: auto;
  border: solid $border-width $divider-color;
  border-radius: $border-radius-default;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.dropdownScrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.dropdownScrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.dropdown {
  overflow-y: auto;
  height: 100%;
  width: 50%;

  .dropdownItem {
    cursor: pointer;
    padding: $spacer * 0.75 $spacer;
    margin: $spacer * 0.25;
    color: $text-default;
    font-weight: $font-weight-medium;
  }

  .active {
    background-color: $primary;
    color: $white;
    border-radius: $border-radius-default;
  }
}
